/**
 * Safe JSON parsing for fetch responses.
 *
 * Handles non-JSON responses (502 gateway errors, HTML error pages, etc.)
 * by returning a typed error ApiResponse instead of throwing.
 */

import type { ApiResponse } from "./types";

export async function safeResponseJson<T>(
  response: Response,
): Promise<ApiResponse<T>> {
  try {
    return await response.json();
  } catch {
    return {
      success: false,
      error: `HTTP ${response.status}: ${response.statusText || "Unexpected response"}`,
    };
  }
}
